/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const X: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="x" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1040.9753846153847 1255.3846153846155H1233.4676923076922L812.9138461538462 767.9292307692307L1307.6923076923076 104.6153846153848H920.3015384615384L616.9169230769231 506.9138461538461L269.6461538461539 104.6153846153848H77.1015384615385L526.9476923076923 626.0184615384616L52.3076923076923 1255.3846153846155H449.5323076923078L723.7815384615385 887.6615384615384L1040.9753846153847 1255.3846153846155zM973.4461538461538 221.4707692307693H1080.1015384615384L391.5753846153846 1144.7015384615386H277.1261538461539L973.4461538461538 221.4707692307693z" : "M832.7803076923077 1004.3076923076922H986.7741538461538L650.3310769230769 614.3433846153846L1046.1538461538462 83.6923076923076H736.2412307692308L493.5335384615385 405.5310769230769L215.7169230769231 83.6923076923076H61.6812307692308L421.5581538461539 500.8147692307692L41.8461538461538 1004.3076923076922H359.6258461538463L579.0252307692308 710.1292307692307L832.7803076923077 1004.3076923076922zM778.756923076923 177.1766153846155H864.0812307692308L313.2603076923077 915.7612307692308H221.7009230769231L778.756923076923 177.1766153846155z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
X.displayName = `Blueprint5.Icon.X`;
export default X;
